// ContactForm.jsx
import { useState } from 'react';
import emailjs from '@emailjs/browser';
// import './ContactForm.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        email: '',
        message: '',
        newsletter: true
    });

    const [status, setStatus] = useState({
        message: '',
        type: '',
        visible: false
    });


    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const handleSubmit = (e) => {
        showStatus('Wysyłanie wiadomości...', 'sending');
        e.preventDefault();

        // Parametry emaila
        const templateParams = {
            email: 'biuro@podatki-saldo.pl',
            time: new Date().getTime(),
            name: formData.email,
            message: formData.message,
            newsletter: formData.newsletter ? 'Tak, chcę się zapisać do newslettera' : 'Nie, nie chcę otrzymywać wiadomości neslettera'
        };

        // Wysłanie emaila - poprawny sposób w React
        emailjs.send('service_ymg05ur', 'template_9esh3q8', templateParams, 'SGuY2KXURxulLYdc8')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                showStatus('Wiadomość została wysłana pomyślnie!', 'success');
                setFormData({
                    email: '',
                    message: '',
                    newsletter: true
                });
            })
            .catch((error) => {
                console.log('FAILED...', error);
                showStatus('Wystąpił błąd podczas wysyłania wiadomości.', 'error');
            });
    };

    const showStatus = (message: string, type: string) => {
        setStatus({
            message,
            type,
            visible: true
        });

        // Ukrycie komunikatu po 5 sekundach
        setTimeout(() => {
            setStatus(prev => ({ ...prev, visible: false }));
        }, 5000);
    };

    return (
        <div className="form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="form-label" htmlFor="email">Email</label>
                    <input
                        className="form-input"
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="form-label" htmlFor="message" style={{color: "white"}}>Wiadomość</label>
                    <textarea
                        className="form-textarea"
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-checkbox-group">
                    <input
                        type="checkbox"
                        id="newsletter"
                        name="newsletter"
                        className="form-checkbox"
                        checked={formData.newsletter}
                        onChange={handleChange}
                    />
                    <label className="form-checkbox-label" htmlFor="newsletter">
                        Zapisz do newslettera
                    </label>
                </div>

                <button className="form-button" type="submit">
                    Wyślij
                </button>
            </form>

            <div className={`status-message ${status.type} ${status.visible ? 'visible' : ''}`}>
                {status.message}
            </div>
        </div>
    );
};

export default ContactForm;
